<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>一致性检查</span>
                        <h1>让您的写作更加专业</h1>
                        <p>只需单击几下即可实现专业的定稿，为您节省大量的时间。Trinka的一致性检查将帮助您修订难以发现的不一致之处，特别是文档比较冗长的情况。</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=CN" id="autoEditGetStart" target="_blank">开始使用</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="assets/images/Consistency-Checks.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/ConsistencyCheckThumbnail.png" alt="" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>看它是如何工作的</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">查看简单的演练视频，立即开始使用一致性检查功能。</p>
                        <p style="margin-bottom: 10px;">这个详细的分步教程可帮助您充分利用Trinka的强大功能。如果您有更多问题，请在
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link remove-space">此处</a>浏览我们的常见问题解答。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Trinka一致性检查的主要特点</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka能够发现写作不一致的地方，让你的写作看起来更加地专业。Trinka能够识别并纠正以下类型的写作不一致：
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards  ">
                        <div class="feature_num">01</div>
                        <h3>拼写</h3>
                        <p class="fearureCardText">Trinka可以识别同一单词的不同拼写，比如
                            <span>美式与英式</span>。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="colourSection" name="spellingchecks" checked>
                                <label for="colourSection">colour (4 occurences) </label>
                            </p>
                            <p>
                                <input type="radio" id="colorSections" name="spellingchecks">
                                <label for="colorSections">color (4 occurences) </label>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards ">
                        <div class="feature_num">02</div>
                        <h3>连字符和破折号</h3>
                        <p class="fearureCardText">Trinka能够发现
                            <span>连字符和破折号</span> 的使用不一致。只需单击鼠标，就可以完成更改，使它们保持一致。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="ultra-violet" name="dashesCehcks" checked>
                                <label for="ultra-violet">ultra-violet (5 occurrences)
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="ultra_violet" name="dashesCehcks">
                                <label for="ultra_violet">ultra violet (5 occurrences)
                                </label>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards ">
                        <div class="feature_num">03</div>
                        <h3>编号样式</h3>
                        <p class="fearureCardText">
                            <span>使用数字和拼写数字</span>是最常见的不一致之一。只需单击鼠标，Trinka就可以帮助您避免它。</p>
                        <div class="custom_radioButtons">
                            <div class="custom_radioButtons">
                                <p>
                                    <input type="radio" id="averagesixyears" name="sadfdashesCehcks" checked>
                                    <label for="averagesixyears">
                                        <b>average six years</b>
                                        <img src="assets/images/spacingArrow.png" />
                                        <b>average 6 years</b>
                                    </label>
                                </p>
                                <p>
                                    <input type="radio" id="averagesix-years" name="sadfdashesCehcks">
                                    <label for="averagesix-years">
                                        <b>average 6 years</b>
                                        <img src="assets/images/spacingArrow.png" />
                                        <b>average six years</b>
                                    </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="feature_num">04</div>
                        <h3>符号</h3>
                        <p class="fearureCardText">Trinka能够理解您交替
                            <span>使用符号或将它们拼出来</span>的这种不一致。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeFourContent_one" name="exampeFourContent" checked>
                                <label for="exampeFourContent_one">
                                    <b>TNF-alpha"</b>
                                    <img src="assets/images/spacingArrow.png" />
                                    <b>tnf-α"</b>
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeFourContent_two" name="exampeFourContent">
                                <label for="exampeFourContent_two">
                                    <b>tnf-α"</b>
                                    <img src="assets/images/spacingArrow.png" />
                                    <b>TNF-alpha"</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="feature_num">05</div>
                        <h3>间距</h3>
                        <p class="fearureCardText">写作中多余的空格很难发现，因此很容易错过。只需在Trinka中单击几下，即可帮助您消除整个写作过程中
                            <span>不一致的间距</span>。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeFiveContent_one" name="exampeFiveContent" checked>
                                <label for="exampeFiveContent_one">
                                    <b>p
                                        <0</b>
                                            <img src="assets/images/spacingArrow.png" />
                                            <b>p
                                                < 0</b>
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeFiveContent_two" name="exampeFiveContent">
                                <label for="exampeFiveContent_two">
                                    <b>p
                                        < 0</b>
                                            <img src="assets/images/spacingArrow.png" />
                                            <b>p
                                                <0</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>


    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>确保你写作的一致和专业</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">开始使用</a>
            </div>
        </div>
    </div>
    <!-- <div class="forpersonlized_sections">
        <p>Experience Advanced Writing Assistance</p>
        <div class="forpersonlizedFooter">
            <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">Get Started</a>
        </div>
    </div> -->
    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>常见问题</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinka的一致性检查是如何工作的？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka的一致性检查会自动查找几种常见的写作不一致，为您列出所有内容，并且为您提供更正选项。您只需选择正确的样式并确认，Trinka将为您完成剩下的更改。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">我在哪里可以找到一致性检查功能？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>一致性检查功能目前在云编辑器上供所有用户使用。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        使用一致性检查功能是否消耗积分？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>目前使用一致性检查功能不需要花费积分。您可以根据需要多次使用该功能。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        我应该何时使用一致性检查功能？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>理想情况下，您应该在写作完成后运行一致性检查功能。但您可以在需要的时候多次运行这个功能。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        使用Trinka的一致性检查修复写作中的不一致
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>使用Trinka的一致性检查，只需单击几下鼠标即可为您节省时间，并让您的写作更加专业。
                                        </p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>在其他应用程序中使用Trinka</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="">
                                            <h3>
                                                <span class="OpenSansFonts" style="font-weight: bold; font-size: 18px">Trinka</span>云</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Others_App_MSWord.svg" alt="">
                                            <h3>
                                                <span class="OpenSansFonts" style="font-weight: bold;font-size: 18px;">Word</span>
                                                <br />插件</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/other_Apps_browser.svg" alt="">
                                            <h3>浏览器插件</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Other_Apps_enterprise.svg" alt="">
                                            <h3 style="margin: 0 0 -2px 0;">企业</h3>
                                            <span class="OpenSansFonts" style="font-size: 10px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="//player.bilibili.com/player.html?aid=728551812&bvid=BV1YS4y177x2&cid=777872825&page=1"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>